import Marquee from "react-fast-marquee";
import { Sparkle } from "lucide-react";

const ITEMS = [
  "Residential Deep Cleaning",
  "Coastal Salt-Removal Window Squeegee",
  "Tropical Lawn Mowing & Garden Care",
  "Weatherproof Exterior Painting",
  "Prompt Repairs & Odd Jobs",
  "Serving Shanzu & Mombasa North Coast",
];

export default function EditorialMarquee() {
  return (
    <div className="relative z-10 -rotate-1 border-y border-[#132A1F] bg-[#1C3B2B] py-4 shadow-[0_20px_50px_-25px_rgba(28,59,43,0.7)]">
      <Marquee speed={28} gradient={false} pauseOnHover>
        {ITEMS.map((item) => (
          <span key={item} className="mx-7 flex items-center gap-7 font-display text-sm font-semibold uppercase tracking-[0.22em] text-[#FBF9F5]">
            {item}
            <Sparkle size={14} className="text-[#D4A359]" />
          </span>
        ))}
      </Marquee>
    </div>
  );
}
